import gsap from 'gsap';

export const careersHeroAnimation = () => {
	const maskSvg = document.querySelector('.mask-svg');
	if (!maskSvg) return;
	const careersMask = document.querySelector('#careers-mask');

	if (!careersMask) return;

	const mask1 = careersMask.querySelector('#mask-1');
	const mask2 = careersMask.querySelector('#mask-2');
	const mask3 = careersMask.querySelector('#mask-3');

	if (!mask1 || !mask2 || !mask3) return;

	gsap.set(careersMask, { y: 400 });

	gsap.set([mask1, mask2, mask3], {
		transformOrigin: '50% 50%',
		scale: 1.4,
	});

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: maskSvg,
			start: 'top 80%',
			end: '+=1500',
			scrub: true,
		},
	});

	tl.to(mask1, {
		x: 365,
		y: 192,
		rotate: 40,
		scale: 1.6,
		duration: 1.2,
		ease: 'none',
	}).to(mask1, {
		scale: 5,
		duration: 1,
		ease: 'none',
		stagger: 0.4,
	});

	const tl2 = gsap.timeline({
		scrollTrigger: {
			trigger: maskSvg,
			start: 'top 80%',
			end: '+=1500',
			scrub: true,
		},
	});

	tl2.to(mask2, {
		x: -344,
		y: 162,
		rotate: -112,
		scale: 1.6,
		duration: 1.2,
		ease: 'none',
	}).to(mask2, {
		scale: 5,
		duration: 1,
		ease: 'none',
		stagger: 0.4,
	});

	const tl3 = gsap.timeline({
		scrollTrigger: {
			trigger: maskSvg,
			start: 'top 80%',
			end: '+=1500',
			scrub: true,
		},
	});

	tl3.to(mask3, {
		x: 472,
		y: 169,
		scale: 1.6,
		duration: 1.2,
		ease: 'none',
	}).to(mask3, {
		scale: 5,
		duration: 1,
		ease: 'none',
		stagger: 0.4,
	});
};
